import { render, staticRenderFns } from "./Genres.vue?vue&type=template&id=69b87fb8&lang=pug&"
import script from "./Genres.vue?vue&type=script&lang=js&"
export * from "./Genres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports